<script type="text/javascript">
    // 定义一些公共的属性和方法
    const indexSwiper = null;
    const showQrcode = false;
    const initLang = navigator.language=='zh-CN'?'zh':'en';//根据浏览器语言设置默认的语言
    // 暴露出这些属性和方法
    export default {
        indexSwiper,
        showQrcode,
        initLang
    }
</script>


// WEBPACK FOOTER //
// src/components/pc/common/common.vue